import React, { useState } from 'react';
import styled from '@emotion/styled';
import AgencyEmptyAvatarIcon from 'assets/svg/briefcase.svg';

const AVATAR_SIZE = {
  small: 64,
  medium: 88,
  large: 112,
};

const Root = styled.div<{ size: 'small' | 'medium' | 'large'; noBorder?: boolean; }>`
  ${({ theme, size = 'medium', noBorder }) => `
    height: ${AVATAR_SIZE[size]}px;
    width: ${AVATAR_SIZE[size]}px;
    ${noBorder ? '' : `
      padding: 3px;
      border: solid 1px ${theme.colors.neutrals.grey8};
    `}
    border-radius: ${theme.borderRadius.medium};
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.neutrals.white};
    > svg {
      width: 48px;
      height: 48px;
    }
    > img {
      object-fit: contain;
      width: 100%;
      height: 100%;
      border-radius: ${theme.borderRadius.small};
    }
  `}
`;

const EmptyAvatarInner = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: ${theme.spacing(0.5)};
    background-color: ${theme.colors.neutrals.grey8};
    border-radius: ${theme.borderRadius.small};
  `}
`;

const AvatarPosition = styled.div<{ size: 'small' | 'medium' | 'large'; }>`
  ${({ theme, size = 'medium' }) => `
    position: absolute;
    margin: 0 auto;
    top: ${theme.spacing(4)};
    left: 0;
    right: 0;
    height: ${AVATAR_SIZE[size]}px;
    width: ${AVATAR_SIZE[size]}px;
  `}
`;

interface AgencyAvatarProps {
  imageUrl?: string;
  size?: 'small' | 'medium' | 'large';
  alt?: string;
  noBorder?: boolean;
}

export const OfficeAvatar: React.FC<AgencyAvatarProps> = props => {
  const { imageUrl, size = 'medium', alt, noBorder } = props;
  const [ imageLoadFailed, setImageLoadFailed ] = useState(false);
  const isImageVisible = imageUrl && !imageLoadFailed;

  const handleFailedLoadImage = () => setImageLoadFailed(true);

  return (
    <AvatarPosition size={size}>
      <Root size={size} noBorder={noBorder}>
        {isImageVisible
          ? <img src={imageUrl} onError={handleFailedLoadImage} alt={alt} />
          : (
            <EmptyAvatarInner>
              <AgencyEmptyAvatarIcon />
            </EmptyAvatarInner>
          )
        }
      </Root>
    </AvatarPosition>
  );
};
